var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.1 137.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #223c6a;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.1,
    cy: 69.3,
    r: 65.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,41.9c-3.5-8.2-8.4-15.5-14.7-21.8-6.3-6.3-13.6-11.2-21.8-14.7-8.5-3.6-17.4-5.4-26.7-5.4s-18.2,1.8-26.7,5.4c-8.2,3.5-15.5,8.4-21.8,14.7-6.3,6.3-11.2,13.6-14.7,21.8C1.8,50.3,0,59.3,0,68.5s1.8,18.2,5.4,26.7c3.5,8.2,8.4,15.5,14.7,21.8s13.6,11.2,21.8,14.7c8.5,3.6,17.4,5.4,26.7,5.4s18.2-1.8,26.7-5.4c8.2-3.5,15.5-8.4,21.8-14.7,6.3-6.3,11.2-13.6,14.7-21.8,3.6-8.5,5.4-17.4,5.4-26.7s-1.8-18.2-5.4-26.7h-.1v.1ZM68.5,132.7c-35.4,0-64.2-28.8-64.2-64.2S33.1,4.3,68.5,4.3s64.2,28.8,64.2,64.2-28.8,64.2-64.2,64.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.2,38.4l12,12c.5.5.5,1.4,0,2l-7,7-13.9-13.9,7-7c.5-.5,1.4-.5,2,0h0l-.1-.1ZM91.3,61.3l-34.7,34.7c-.2.2-.5.3-.7.4-.7.2-8.1,2.2-8.1,2.2l-8.2,2.2c-.7.2-1.5-.2-1.7-1v-.7l2.2-8.2h0l2.2-8.2c0-.2.2-.5.4-.6h0l34.7-34.7s13.9,13.9,13.9,13.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.aa1a521c1a5ec60d29fa8732991e5c14.svg";
export { ForwardRef as ReactComponent };